import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawBoltIcon from "./RawBoltIcon.svg.jsx";

const BoltIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawBoltIcon} {...props} />;
});

export default BoltIcon;
